import { PropertyDetails } from "../../shared/data-objects/property-details";
import { ApplicationBase } from "../../shared/data-objects/application-base";
import { User } from "../../shared/data-objects/user";
import {
  WorkrequestGreenField,
  WorkrequestPsaDetails,
} from "./workrequest-psa-details";
import { UploadfilesViewmodel } from "../../shared/viewmodels/uploadfiles-viewmodel";

/**
 * Created by Boris on 14/02/2017.
 */
export class Psa extends ApplicationBase {
  propertyDetails?: PropertyDetails;
  workRequestPsa?: WorkrequestPsaDetails;
  workRequestDetails?: any;
  workrequestGreenField?: WorkrequestGreenField;
  owner?: User;
  consultant?: ConsultantDetails;
  planType?: string;
  valAdressGeoSpace: boolean;
  LodgedAsOwner: boolean;

  constructor() {
    super();
    this.propertyDetails = new PropertyDetails();
    this.workRequestPsa = new WorkrequestPsaDetails();
    this.workrequestGreenField = new WorkrequestGreenField();
    this.owner = new User();
    this.consultant = new ConsultantDetails();
  }

  checkNumber(evt) {
    if (
      (evt.which != 8 && evt.which != 0 && evt.which < 48) ||
      evt.which > 57
    ) {
      evt.preventDefault();
    }
  }

  RestrictCommaSemicolon(e) {
    var theEvent = e || window.event;

    var key = theEvent.keyCode || theEvent.which;

     key = String.fromCharCode(key);   

    var regex = /[^~`!@$%^*_+={};":<>?|\[\]]+$/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  }
}

export class ConsultantDetails extends User {
  consultantDescription: string;
}



// WEBPACK FOOTER //
// ./src/app/create-application/psa-form/psa.ts